import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, watch} from "vue";
import {ref} from "vue";

interface Props{
  modelValue:any,
  readonly:boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TimePicker',
  props: {
    modelValue: { default: [] },
    readonly: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props=__props
// const sValue = computed({
//   get() {
//     return props.modelValue
//   },
//   set(value) {
//     emit("update:modelValue", value)
//   }
// });
const sValue=ref([]);
watch(()=>props.modelValue,(newval)=>{
  console.log('modelValue',newval,newval.split('-'))
  sValue.value=newval.split('-');
},{immediate:true})
//todo 向外抛值
const emit = __emit;
const show=ref(false);

const confirm=()=>{
  console.log(212)
  emit("update:modelValue", sValue.value.join('-'));
  show.value=false;
  console.log(sValue,sValue.value)
}


return (_ctx: any,_cache: any) => {
  const _component_van_date_picker = _resolveComponent("van-date-picker")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["van-cell flex-n", [_ctx.modelValue.length>0?'': 'empty',_ctx.readonly?'readonly':'']]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.readonly?'':show.value=true))
    }, _toDisplayString(_ctx.modelValue.length>0?_ctx.modelValue: (_ctx.readonly?'':'请选择日期')), 3),
    _createVNode(_component_van_action_sheet, {
      show: show.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_date_picker, {
          modelValue: sValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sValue).value = $event)),
          title: "选择日期",
          readonly: _ctx.readonly,
          "min-date": new Date(1900, 0, 1),
          "max-date": new Date(2099, 11, 31),
          onConfirm: confirm,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (show.value=false))
        }, null, 8, ["modelValue", "readonly", "min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})